import React from "react";
import {
    Alert,
    Row,
    Col,
    Card,
    CardHeader,
    Badge,
    CardBody
} from "reactstrap";
import {
    groupInstallmentsByCard,
    getCardBrandColor,
    getCardBrandName
} from "../../../../utils/installmentHelpers";

export default function InstallmentRateCards({ group }) {
    if (!group || !group.installmentRates) {
        return <Alert color="warning">Taksit bilgisi bulunamadı.</Alert>;
    }
    const grouped = groupInstallmentsByCard(group.installmentRates);
    const brands = Object.keys(grouped);

    if (brands.length === 0) {
        return <Alert color="warning">Aktif taksit oranı yok.</Alert>;
    }

    return (
        <Row>
            {brands.map((brand) => (
                <Col xs={12} sm={6} lg={6} xl={4} key={brand} className="mb-3">
                    <Card>
                        <CardHeader className="bg-light py-2">
                            <Badge color={getCardBrandColor(brand)} className="me-2">
                                {getCardBrandName(brand)}
                            </Badge>
                            <small>{grouped[brand].length} seçenek</small>
                        </CardHeader>
                        <CardBody className="p-2">
                            <table className="table table-sm mb-0">
                                <thead>
                                <tr>
                                    <th>Taksit</th>
                                    <th>Komisyon %</th>
                                </tr>
                                </thead>
                                <tbody>
                                {grouped[brand]
                                    .sort((a, b) => a.installmentCount - b.installmentCount)
                                    .map((r) => (
                                        <tr key={r.id}>
                                            <td>{r.installmentCount}</td>
                                            <td>{r.commissionPercent.toFixed(2)}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
}